// extracted by mini-css-extract-plugin
export default {"wrapper":"EditableFlagImage_wrapper__cdIlV","flagImage":"EditableFlagImage_flagImage__dt0R8","background":"EditableFlagImage_background__ESfbP"};